import { Breadcrumb } from "flowbite-react";
import { H4 } from "../typography/H4";

interface Props {
  openModal: () => void;
}

export const AdminAdminHeader: React.FC<Props> = ({ openModal }) => {
  return (
    <div className="flex flex-col">
      <Breadcrumb className="pb-0">
        <Breadcrumb.Item>관리자 정보</Breadcrumb.Item>
        <Breadcrumb.Item>관리자 정보</Breadcrumb.Item>
      </Breadcrumb>
      {/* <div className="flex items-center justify-between h-[50px] mb-[28px]"> */}
      <div className="mt-[14px] mb-[16px]">
        <H4>관리자 정보</H4>
      </div>
      {/* <Button color={ButtonColor.PRIMARY} onClick={openModal}>
          관리자 추가
        </Button> */}
      {/* </div> */}
    </div>
  );
};
